import React, { Component } from 'react';
import styles from './CarouselFooter.css';

const debug = _debug('app:carouselFooter');
class CarouselFooter extends Component {
  static propTypes = {
    buttonCarouselAction: React.PropTypes.func,
    clickedIndex: React.PropTypes.number,
    disabled: React.PropTypes.shape({}),
    strings: React.PropTypes.shape({}),
  }

  constructor(props) {
    super(props);
    debug(props);
    const propsData = this.props.disabled;
    this.disabled = ((propsData.status === '4') || (propsData.status === '5'));
  }
  disabled = true;
  render() {
    const tabbedData = this.props.disabled;
    const { strings } = this.props;
    return (
      <div className={styles.carouselFooter}>
        <button
          type="button"
          className={this.disabled ?
            styles.disabledFooterCarouselComponent : styles.footerCarouselComponent}
          disabled={this.disabled}
          onClick={() => !this.disabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'attemptedContact')}
        >
          <input
            type="image"
            src="static/att_contact_ico.png"
            alt="Attempted Contacts"
            disabled={this.disabled}
            className={styles.footerCarouselButton}
          />
          <span
            className={styles.footerCarouselLabel}
            disabled={this.disabled}
          >{strings.attemptedContacts}
          </span>
        </button>
        <button
          disabled={this.disabled}
          className={this.disabled ?
            styles.disabledFooterCarouselComponent : styles.footerCarouselComponent}
          onClick={() => !this.disabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'appointment')}
        >
          <input
            type="image"
            src="static/appoinment_ioc.png"
            alt="Appoinment"
            className={styles.footerCarouselButton}
          />
          <span className={styles.footerCarouselLabel} >{strings.appointment}</span>
        </button>
        <button
          disabled={this.disabled}
          className={this.disabled ?
            styles.disabledFooterCarouselComponent : styles.footerCarouselComponent}
          onClick={() => !this.disabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'sale')}
        >
          <input
            type="image"
            src="static/sale.png"
            alt="sale"
            className={styles.footerCarouselButton}
          />
          <span className={styles.footerCarouselLabel} >{strings.sale}</span>
        </button>
        <button
          className={this.disabled ?
            styles.disabledFooterCarouselComponent : styles.footerCarouselComponent}
          disabled={this.disabled}
          onClick={() => !this.disabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'nosale')}
        >
          <input
            type="image"
            src="static/no-sale.png"
            alt="No Sale"
            disabled={this.disabled}
            className={styles.footerCarouselButton}
          />
          <span
            className={styles.footerCarouselLabel}
            disabled={this.disabled}
          >
            {strings.noSale}
          </span>
        </button>
        {(tabbedData.leadType === 'Active' || tabbedData.leadType === 'Lapsed' || (tabbedData.leadType === 'Campaign' && (tabbedData.campaignLeadType === 1 || tabbedData.campaignLeadType === 2))) &&
          <button
            className={this.disabled ?
              styles.disabledFooterCarouselComponent : styles.footerCarouselComponent}
            disabled={this.disabled}
            onClick={() => (tabbedData.leadType === 'Active' || tabbedData.leadType === 'Lapsed' || (tabbedData.leadType === 'Campaign' && (tabbedData.campaignLeadType === 1 || tabbedData.campaignLeadType === 2))) && !this.disabled && this.props.buttonCarouselAction(this.props.clickedIndex, 'edit')}
          >
            <input
              type="image"
              src="static/edit.png"
              alt="Edit"
              className={styles.footerCarouselButton}
            />
            <span className={styles.footerCarouselLabel}>{strings.edit}</span>
          </button>
        }
      </div>
    );
  }
}
export default CarouselFooter;



// WEBPACK FOOTER //
// ./src/components/CarouselFooter/CarouselFooter.js